import { type ReactElement } from "react";
import { useAuthenticated } from "@/zapi-frontend/shared/hooks/useAuthenticated";
import { useHistoricalNavigate } from "@/zapi-frontend/shared/hooks/useHistoricalNavigate";

type TProps = {
  children: ReactElement;
};

export function NonProtectedRoute({ children }: TProps) {
  const { navigate } = useHistoricalNavigate();
  const { data: isAuth, isLoading } = useAuthenticated();

  if (isLoading) {
    return null;
  }

  if (isAuth) {
    navigate("/");
    return null;
  }

  return <div>{children}</div>;
}
